import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anon) {
  console.warn('VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY missing.');
}

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// ─── Auth helpers ──────────────────────────────────────────────────────

function buildCallbackUrl(nextPath) {
  const base = window.location.origin;
  const next = nextPath ? `?next=${encodeURIComponent(nextPath)}` : '';
  return `${base}/auth/callback${next}`;
}

export async function signInWithGoogle(nextPath) {
  return supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: buildCallbackUrl(nextPath),
      queryParams: {
        access_type: 'offline',
        prompt: 'consent',
      },
    },
  });
}

export async function signInWithPassword(email, password) {
  return supabase.auth.signInWithPassword({ email, password });
}

export async function signUpWithPassword(email, password) {
  return supabase.auth.signUp({
    email,
    password,
    options: {
      data: { user_type: 'interviewee' },
      emailRedirectTo: buildCallbackUrl('/onboarding'),
    },
  });
}

export async function signInWithMagicLink(email, nextPath) {
  return supabase.auth.signInWithOtp({
    email,
    options: {
      emailRedirectTo: buildCallbackUrl(nextPath),
      shouldCreateUser: true,
      data: { user_type: 'interviewee' },
    },
  });
}

export async function signOut() {
  return supabase.auth.signOut();
}

export async function getSession() {
  return supabase.auth.getSession();
}
